import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemeProvider } from './context/theme.context';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/auth.context';
import PostsProvider from './context/posts.context';
import { MockDataProvider } from './context/mock-data.context';
import ErrorBoundary from './components/error-boundary/error-boundary.component';

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router>
        <ThemeProvider>
          <MockDataProvider>
            <AuthProvider>
              <PostsProvider>
                <App />
              </PostsProvider>
            </AuthProvider>
          </MockDataProvider>
        </ThemeProvider>
      </Router>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);
